// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SearchForInstitutionCourseByStringHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import InstitutionCourseDTO from '../models/InstitutionCourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    searchText: string | null;
    institutionId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            searchText: "",
            institutionId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    searchText: 'searchText',
    institutionId: 'institutionId',
}

interface Result extends ResultDTO {
    institutionCourses: InstitutionCourseDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            institutionCourses: [],
        },
        initValues);
    },
    institutionCourses: 'institutionCourses',
}

export { Request, Result };